export default "__VITE_PUBLIC_ASSET__24142f13__"